import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SeasonMapped, SeasonMappedResult } from '@/core/interfaces';

interface SeasonState {
  seasons: SeasonMapped[];
}

const initialState: SeasonState = {
  seasons: [],
};

const seasonSlice = createSlice({
  name: 'season',
  initialState,
  reducers: {
    setSeasonData: (state, action: PayloadAction<SeasonMappedResult>) => {
      state.seasons = action.payload.seasons
    },
    clearSeasons: (state) => {
      state.seasons = [];
    },
  },
});

const { reducer, actions } = seasonSlice;

export const { setSeasonData, clearSeasons } = actions;
export default reducer;